import { APP } from '../../config';
import { getGeoIP } from '../consumer/DeviceLocation';
import exceptionLogger from '../exceptionLogger';
import { setLandingInfo } from '../landingInfo';
import { SESSION_STORAGE_LANDING_EVENT_KEY } from './constants';
import newAnalytics from './index';
import type { IRouteState } from '../../../../packages/router';

export const hasFiredLanding = () => {
  let hasLanded = false;
  try {
    hasLanded = sessionStorage
      .getItem(SESSION_STORAGE_LANDING_EVENT_KEY) === 'true';
  } catch (e) {
    exceptionLogger(e);
    // eslint-disable-next-line no-console
    console.error(e);
  }

  return hasLanded;
};

type LandingProps = {
  landing_page: string;
  landing_route_state: string;
  latitude: number | null;
  longitude: number | null;
  ncd_source?: string;
  ncd_term?: string;
  referring_tracking_cookie?: string;
};

export const fireLanding = async (routeState: IRouteState) => {
  const oldStateNameToLandingPage = {
    start: 'home',
    'search.list': 'search',
    profile: 'profile',
  };

  const landingPage = APP
    ? routeState.name
    : (oldStateNameToLandingPage[routeState.name] || routeState.name);

  const location = await getGeoIP();

  setLandingInfo({
    page: landingPage,
    url: window.document.location.href,
    referrer: window.document.referrer,
  });

  const landingProperties: LandingProps = {
    landing_page: landingPage,
    landing_route_state: routeState.name,
    latitude: location && location.latitude ? Number(location.latitude) : null,
    longitude: location && location.longitude ? Number(location.longitude) : null,
  };

  if (routeState.params?.ncd_source) {
    landingProperties.ncd_term = routeState.params.ncd_term;
    landingProperties.ncd_source = routeState.params.ncd_source;
    landingProperties.referring_tracking_cookie = routeState.params.referral_id;
  }

  newAnalytics.land(landingProperties);

  sessionStorage
    .setItem(SESSION_STORAGE_LANDING_EVENT_KEY, 'true');
};
